export default __webpack_public_path__ + "static/media/careerCounsellor.ac16d46e.jpg";